var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / BZ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-BZ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-4",
    fill: "#094995",
    mask: "url(#mask-2)",
    x: 0,
    y: 2.66666667,
    width: 28,
    height: 14.6666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#D5182F",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#D5182F",
    mask: "url(#mask-2)",
    x: 0,
    y: 17.3333333,
    width: 28,
    height: 2.66666667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-12",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    cx: 14,
    cy: 10,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,14 C16.209139,14 18,12.209139 18,10 C18,7.790861 16.209139,6 14,6 C11.790861,6 10,7.790861 10,10 C10,12.209139 11.790861,14 14,14 Z",
    id: "Oval-73",
    stroke: "#118014",
    strokeWidth: 1.33333333,
    strokeLinecap: "round",
    strokeDasharray: "0.6666666666666666,2",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBz);
export default __webpack_public_path__ + "static/media/BZ.71f05903ddf433f6d10984a3fe876e5d.svg";
export { ForwardRef as ReactComponent };